import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import BusinessIcon from "@mui/icons-material/Business";

export default function KYCAML() {
  return (
    <Box component="main" sx={{ py: 8, background: "#f8fafc" }}>
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Typography variant="h4" fontWeight={800}>
            KYC / AML Compliance Policy
          </Typography>

          <Typography>
            FentrixBank maintains strict Know-Your-Customer (KYC) and Anti-Money
            Laundering (AML) controls to comply with international regulatory
            obligations and protect our customers and the financial system.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            1. Customer Identification & Verification
          </Typography>

          <List>
            <ListItem>
              <ListItemIcon>
                <VerifiedUserIcon />
              </ListItemIcon>
              <ListItemText
                primary="Required Documents"
                secondary="Government-issued ID (passport, national ID, driver's license), proof of address, and a live selfie or biometric check when required."
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <BusinessIcon />
              </ListItemIcon>
              <ListItemText
                primary="Enhanced Due Diligence"
                secondary="Applied to politically exposed persons (PEPs), high-risk jurisdictions, or when transaction patterns indicate elevated risk."
              />
            </ListItem>
          </List>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            2. Transaction Monitoring & Controls
          </Typography>

          <Typography>
            We use automated monitoring systems to detect unusual patterns, velocity,
            and anomalies. Alerts trigger reviews and, where necessary, we file SARs
            (Suspicious Activity Reports) with competent authorities.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            3. Recordkeeping & Reporting
          </Typography>

          <Typography>
            Records of customer identification and transaction logs are retained
            according to legal and regulatory requirements. We cooperate with law
            enforcement and regulators where appropriate.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            4. Account Actions
          </Typography>

          <List>
            <ListItem>
              <ListItemIcon>
                <ReportProblemIcon />
              </ListItemIcon>
              <ListItemText primary="Suspension / Freezing" secondary="Accounts may be temporarily suspended pending investigation." />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <ReportProblemIcon />
              </ListItemIcon>
              <ListItemText primary="Closure" secondary="Persistent non-compliance or illegal activity may result in account closure." />
            </ListItem>
          </List>

          <Typography variant="body2" color="text.secondary">
            For questions about KYC/AML requirements or documentation, contact{" "}
            <strong>compliance@fentrixbank.com</strong>.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}